import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const CheckoutFeeSubtitle = styled(TextBase)`
  font-size: 0.875rem;
`;

export const CheckoutFeeText = styled(TextBase)`
  color: ${({ theme }) => theme.colors.green.default};
`;

export const DefaultCheckoutFeeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
